import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import swal from 'sweetalert';
import axios from "axios";
import _ from "lodash";
import "../../assets/css/pages/notifications.css";

export default function () {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector(state => state.token);
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;

  const [idFilter, setIdFilter] = useState(null);
  const [messageFilter, setMessageFilter] = useState(null);

  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  useEffect(() => {
    triggerDatatable();
  }, []);

  const getHeaderNotifications = () => {
    axios.get('take-several-notifications/10').then(res => {
      dispatch({type: 'PUT_NOTIFICATION', count: res?.data?.notifications_data?.not_read_count});
    });
  }

  const triggerFilter = (e) => {
    e.preventDefault();
    localStorage.removeItem("DataTables_notifications_/notifications")
    triggerDatatable();
  }

  const triggerDatatable = () => {

    let table = $('#notifications').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "notifications/filter",
        method: 'POST',
        data: {
          id: idFilter,
          message: messageFilter,
        },
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      "destroy": true,
      "columns": [
        {
          data: 'checkbox',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>
                    `;
          },
        },
        {data: 'id', name: 'id'},
        {
          data: 'is_read',
          serchable: false,
          render: function (data, type, row) {
            if (row?.is_read == false) {
              return `<div class="indicator bg-primary"></div>`;
            } else {
              return ``;
            }

          },
        },
        {data: 'title', name: 'title'},
        {
          data: 'message',
          orderable: false,
          render: function (data, type, row) {
            return `<div class="ls-1 fw-light ellipsis message">
                       ${row?.message}
                    </div>`;
          },
        },
        {
          data: 'actions',
          serchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `<button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 show"
                            row-id="${row.id}" row-name="${row.title}">
                                <i class="fas fa-eye"></i> Show
                            </button>
                            ${row.is_read == false ? `<button
                              class="btn btn-primary me-2 mb-4 mt-1 read"
                              row-id="${row.id}" row-name="${row.title}">
                              <i class="fas fa-check-circle"></i> Mark read
                            </button>` : ""}
                            <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.title}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>`;
          },
        }
      ],
      "order": [[1, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.show', function () {
      const id = ($(this).attr("row-id"));
      navigate('/notifications/' + id);
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteNotification(id, name, table, $(this));
    });

    table.on('click', 'button.read', function () {
      const id = ($(this).attr("row-id"));
      markRead(id, table, $(this));
    });

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    $(`<span class='table-filter-icon' title='Filter'>
        <i class='fa fa-filter fs-4 br-1000'></i>Filter
        </span>`).insertAfter("#notifications_length label");

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon").html("<i class='far fa-times-circle fs-4 br-1000'></i>Close");
      }
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
    .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
         <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
         <span class="checkmark"><span></span></span>
         </label>`);

    $(".table-filter-icon").click(function () {
      $(".toggle-filter").slideToggle(100)

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

  };

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const markRead = (id, table, thisElement) => {
    axios.post('/mark-notifications-read/' + id)
      .then(function (res) {
        if (res.status == 200) {
          thisElement.parents("tr").children("td").children(".indicator").remove();
          thisElement.remove();

          dispatch({type: 'DECREMENT_NOTIFICATION'});
        }
      });
  }

  const deleteNotification = (id, name, table, selector) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete notification "' + name + '"?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('notifications/' + id, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }).then(function (res) {
          console.log(res);
          if (res.status == 200) {
            swal('The notification "' + name + '" has been deleted!', {
              icon: "success",
            });
            deleteRow(table, selector);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  //Bulk Action Start()

  const bulkNotificationsRead = () => {
    swal({
      title: "Are you sure?",
      text: `You want to mark as read these notifications?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.post('bulk-notifications-read', {
          notifications: bulkArray,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal("Notifications has been marked as read!", {
                icon: "success",
              });
              resetMarked();
              getHeaderNotifications()
              $('#notifications').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }

  const bulkNotificationsDestroy = () => {
    swal({
      title: "Are you sure?",
      text: `You want to delete marked notifications?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.post('bulk-notifications-destroy', {
          notifications: bulkArray,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal("Notifications has been deleted successfully!", {
                icon: "success",
              });
              resetMarked();
              getHeaderNotifications()
              $('#notifications').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }

  //Bulk Action End()

  return (
    <>
      <div>
        <div className="toggle-filter display-none">
          <form onSubmit={triggerFilter} className="row">

            <div className="fv-row mb-10 col-xl-3 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">ID</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="id"
                     onChange={(e) => {
                       setIdFilter(e.target.value)
                     }}
                     value={idFilter}
              />
            </div>
            <div className="fv-row mb-10 col-xl-7 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Message</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="message"
                     onChange={(e) => {
                       setMessageFilter(e.target.value)
                     }}
                     value={messageFilter}
              />
            </div>
            <div className="col-xl-2 pt-xl-8 text-xl-end">
              <button
                className="btn btn-primary py-4"
                title="Filter Table"
                type="submit"
                onClick={triggerFilter}
              >
                <i className="fas fa-sync-alt fs-5 mr-2"></i>
                Filter
              </button>
            </div>
          </form>
        </div>
        <div className="d-block text-right pb-5">
          <div className={`marked-actions${buttonIsDisabled ? " invisible" : ""}`}>
            <button
              type="button"
              className="btn btn-success mr-3"
              onClick={() => bulkNotificationsRead()}
              disabled={buttonIsDisabled}
            >
              <i class="fas fa-check-circle mr-2"></i>
              Mark as read
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => bulkNotificationsDestroy()}
              disabled={buttonIsDisabled}
            >
              <i className="fas fa-lock mr-2"></i>
              Delete
            </button>
          </div>
        </div>
        <table id="notifications" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th></th>
            <th>ID</th>
            <th>New</th>
            <th>Title</th>
            <th>Message</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold"></tbody>
        </table>
      </div>
    </>
  );
}